import { SunkenBox } from '@ewf/components/SunkenBox';
import walletConnectLogo from '@ewf/assets/logos/wallet-connect.svg';
import ledgetLogo from '@ewf/assets/logos/ledger.svg';
import { WalletButton } from './WalletButton';
import { MARKETPLACE_CHAINS } from '@shared/types/enums';
import { isElectron } from '@shared/utils/is-electron';

export const WalletSelector = ({
  selectedWallet,
  setSelectedWallet,
  network,
}: Props): JSX.Element => {
  const selectWalletConnect = () => setSelectedWallet('wallet-connect');
  const selectLedger = () => setSelectedWallet('ledger');

  return (
    <div className="rounded-lg p-6 bg-popup-gradient">
      <SunkenBox className="mb-8 text-center">
        <p className="mb-1 text-lg font-bold text-white">Connect to {network} Account</p>
        <p className="text-md text-font-subtle">Select your preferred wallet</p>
      </SunkenBox>
      <div className="grid grid-cols-2 gap-6">
        <WalletButton
          isSelected={selectedWallet === 'wallet-connect'}
          onSelect={selectWalletConnect}
        >
          <img src={walletConnectLogo} width={56} height={56} alt="Wallet connect" />
          <p>Wallet Connect</p>
        </WalletButton>
        <WalletButton
          isSelected={selectedWallet === 'ledger'}
          onSelect={selectLedger}
          disabled={!isElectron()}
        >
          <img src={ledgetLogo} width={56} height={56} alt="Wallet connect" />
          <p>Ledger</p>
        </WalletButton>
      </div>
    </div>
  );
};

export type Wallet = 'wallet-connect' | 'ledger';
interface Props {
  selectedWallet: Wallet;
  setSelectedWallet: (wallet: Wallet) => void;
  network: MARKETPLACE_CHAINS;
}
